import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { BaseChartDirective, Color, Label, MultiDataSet, PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import * as pluginAnnotations from 'chartjs-plugin-annotation';

export class CircleDiagramData {
  label: string;
  value: number;
}

@Component({
  selector: 'ngx-circle-diagram',
  templateUrl: './circle-diagram.html',
  styleUrls: ['./circle-diagram.scss'],
})
export class CircleDiagram implements OnInit, OnChanges {
  @Input() totalCost = '0';
  @Input() data = [
    {
      label: 'Overlijdensrisicoverzekering!',
      value: 10
    },
    {
      label: 'AVO-vaste lastenverzekering',
      value: 15
    },
    {
      label: 'Hypotheek',
      value: 20
    },
  ];


  public doughnutChartLabels: Label[] = ['Overlijdensrisicoverzekering', 'AVO-vaste lastenverzekering', 'Hypotheek'];
  public doughnutChartData: MultiDataSet = [
    [65, 25, 15],
  ];
  public doughnutChartType: ChartType    = 'doughnut';

  public doughnutChartOptions: ChartOptions = {
    responsive      : true,
    cutoutPercentage: 80,
    tooltips: {
      enabled: false
    },
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
      labels: {
        fontFamily: 'Roboto Regular'
      }
    }
  };

  public doughnutChartColors: Color[]                                      = [
    {
      backgroundColor: [
        '#765ca7',
        '#e74699',
        '#2b60ad',
      ]
    },
  ];

  public doughnutChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [{
    beforeDraw: this.getBeforeDraw()
  }];

  updateChartDataFromInput() {
    const labels = [];
    const values = [];
    for (const datum of this.data) {
      labels.push(datum.label);
      values.push(datum.value);
    }

    this.doughnutChartLabels = labels;
    this.doughnutChartData = [values];
  }

  getBeforeDraw() {
    const vm = this;
    return (chart) => {
      const ctx = chart.ctx;
      const txt = 'Center Text';

      // Get options from the center object in options
      const sidePadding           = 80;
      const sidePaddingCalculated = (sidePadding / 100) * (chart['innerRadius'] * 2);

      ctx.textAlign    = 'center';
      ctx.textBaseline = 'hanging';
      const centerX    = ((chart.chartArea.left + chart.chartArea.right) / 2);
      const centerY    = ((chart.chartArea.top + chart.chartArea.bottom) / 2) - 10;

      // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      const stringWidth = ctx.measureText(txt).width;

      const elementWidth = (chart['innerRadius'] * 2) - sidePaddingCalculated;

      // Find out how much the font can grow in width.
      const widthRatio    = elementWidth / stringWidth;
      const newFontSize   = Math.floor(30 * widthRatio);
      const elementHeight = (chart['innerRadius'] * 2);

      // Pick a new font size so it will not be larger than the height of label.
      let fontSizeToUse = 5;

      ctx.font      = fontSizeToUse + 'vh Roboto Bold, sans-serif';
      ctx.fillStyle = '#2e384d';

      // Draw text in center
      const textSize = 12;
      ctx.fillText(vm.totalCost, centerX, centerY - 20);
      // Draw percentage
      const numbers = ctx.measureText(this.totalCost).width;
      fontSizeToUse = 2.5;
      ctx.font      = fontSizeToUse + 'vh Roboto Bold';
      // ctx.fillText('%', centerX + ((numbers - 10) / 2) + 3, centerY - 20);

      fontSizeToUse = 1.5;
      ctx.font      = fontSizeToUse + 'vh Roboto';
      ctx.fillStyle = '#b0bac9';
      ctx.fillText('TOTALE', centerX, centerY + 30);
      ctx.fillText('KOSTEN', centerX, centerY + 45);
      // ctx.strokeText('service needed', centerX, centerY);
    };
  }

  constructor() { }

  ngOnInit() {
    this.updateChartDataFromInput();
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.updateChartDataFromInput();
  }
}
